import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';
import { NewsletterInline } from '../conversion/NewsletterInline';

export interface NewsletterBlockProps {
  title?: string;
  description?: string;
}

export function NewsletterBlock({ title, description }: NewsletterBlockProps) {
  return (
    <section className="bg-stone-50 py-12">
      <Container className="max-w-2xl">
        <NewsletterInline title={title || undefined} description={description || undefined} />
      </Container>
    </section>
  );
}

export const NewsletterBlockConfig: ComponentConfig<NewsletterBlockProps> = {
  fields: {
    title: { type: 'text' },
    description: { type: 'textarea' },
  },
  defaultProps: {
    title: '',
    description: '',
  },
  render: NewsletterBlock,
};
